import { createSlice } from '@reduxjs/toolkit'

import { customersApi } from '../services/customers'

const initialState = {
    customers: [],
    selectedCustomer: null, // Used for quote customer selection
    selectedCustomerId: null, // Used for quote customer selection
    customerCentralSelectedCustomer: null, // Used for Customer Central viewing context
    customerCentralSelectedCustomerId: null, // Used for Customer Central viewing context
    showAddCustomerForm: false,
    currentTab: 0, // Customer Central tab index (0 = Summary, 3 = Quote History, etc.)
}

export const customersSlice = createSlice({
    name: 'customersSlice',
    initialState,
    reducers: {
        setCustomers: (state, action) => {
            state.customers = action.payload
        },
        setSelectedCustomer: (state, action) => {
            state.selectedCustomer = action.payload
        },
        setSelectedCustomerId: (state, action) => {
            state.selectedCustomerId = action.payload
        },
        setCustomerCentralSelectedCustomer: (state, action) => {
            state.customerCentralSelectedCustomer = action.payload
        },
        setCustomerCentralSelectedCustomerId: (state, action) => {
            state.customerCentralSelectedCustomerId = action.payload
        },
        setShowAddCustomerForm: (state, action) => {
            state.showAddCustomerForm = action.payload
        },
        setCurrentTab: (state, action) => {
            state.currentTab = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(customersApi.endpoints.getCustomers.matchFulfilled, (state, { payload }) => {
            state.customers = payload
        })
    },
})

export const selectCustomers = (state) => state.customersSlice.customers
export const selectSelectedCustomer = (state) => state.customersSlice.selectedCustomer
export const selectSelectedCustomerId = (state) => state.customersSlice.selectedCustomerId
export const selectCustomerCentralSelectedCustomer = (state) => state.customersSlice.customerCentralSelectedCustomer
export const selectCustomerCentralSelectedCustomerId = (state) => state.customersSlice.customerCentralSelectedCustomerId
export const selectShowAddCustomerForm = (state) => state.customersSlice.showAddCustomerForm
export const selectCurrentTab = (state) => state.customersSlice.currentTab

export const {
    setCurrentTab,
    setCustomerCentralSelectedCustomer,
    setCustomerCentralSelectedCustomerId,
    setCustomers,
    setSelectedCustomer,
    setSelectedCustomerId,
    setShowAddCustomerForm,
} = customersSlice.actions

export default customersSlice.reducer
